export const MIN_MAX_FIELD_VALIDITY = '-?(0|[1-9]([0-9]*|[0-9]{0,2}(,[0-9]{3})+))(.[0-9]+)?%?';
export const GENERAL_DECIMAL_NUMBER_PATTERN = '-?(0|[1-9]([0-9]*|[0-9]{0,2}(,[0-9]{3})+))(.[0-9]+)?';
